import { render, staticRenderFns } from "./CargoImportStatus.vue?vue&type=template&id=2bdccde0"
import script from "./CargoImportStatus.vue?vue&type=script&lang=js"
export * from "./CargoImportStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports